import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SelectPlanPartialComponent } from './partials/select-plan-partial/select-plan-partial.component';
import { DragdropDirective } from './directives/dragdrop.directive';
import { ConvertTimestampPipe } from './tenable/pipes/convert-timestamp.pipe';
import { FileUploaderInputComponent } from './partials/file-uploader-input/file-uploader-input.component';
import { CompanyInviteFormComponent } from './partials/company-invite-form/company-invite-form.component';
import { CheckoutBarComponent } from './partials/checkout-bar/checkout-bar.component';
import { PromoCodeBoxComponent } from './partials/promo-code-box/promo-code-box.component';
import { PartnerPlanNoteComponent } from './partials/partner-plan-note/partner-plan-note.component';
import { PlanStepsComponent } from './partials/plan-steps/plan-steps.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DateCheckPipe } from './pipes/date-check.pipe';
import { CeilPipe } from './pipes/ceil.pipe';
import { HostnameConversionPipe } from './pipes/hostname-conversion.pipe';
import { SortableDirective } from './directives/sortable.directive';
import { HumanizeKeyPipe } from './pipes/humanize-key.pipe';
import { SalesDashboardComponent } from './components/sales-dashboard/sales-dashboard.component';
import {
  HasPermissionDirective,
  HasRoleDirective,
  HasRoleLevelDirective,
  HasAnyPermissionDirective,
  HasAllPermissionsDirective,
} from './directives/permission.directive';

@NgModule({
  declarations: [
    SelectPlanPartialComponent,
    DragdropDirective,
    ConvertTimestampPipe,
    DateCheckPipe,
    CeilPipe,
    HumanizeKeyPipe,
    FileUploaderInputComponent,
    CompanyInviteFormComponent,
    CheckoutBarComponent,
    PromoCodeBoxComponent,
    PartnerPlanNoteComponent,
    PlanStepsComponent,
    HostnameConversionPipe,
    SortableDirective,
    HasPermissionDirective,
    HasRoleDirective,
    HasRoleLevelDirective,
    HasAnyPermissionDirective,
    HasAllPermissionsDirective,
  ],
  exports: [
    SelectPlanPartialComponent,
    DragdropDirective,
    ConvertTimestampPipe,
    DateCheckPipe,
    CeilPipe,
    HumanizeKeyPipe,
    FileUploaderInputComponent,
    CompanyInviteFormComponent,
    CheckoutBarComponent,
    PromoCodeBoxComponent,
    PartnerPlanNoteComponent,
    PlanStepsComponent,
    HostnameConversionPipe,
    SortableDirective,
    SalesDashboardComponent,
    HasPermissionDirective,
    HasRoleDirective,
    HasRoleLevelDirective,
    HasAnyPermissionDirective,
    HasAllPermissionsDirective,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    SalesDashboardComponent,
  ],
  providers: [DatePipe],
})
export class CoreModule {}
